app            = require("app")
device         = require("lib/device")
BaseSlidesView = require("views/base/slides")
{ Sound } = Application.actions()
{ getValidAncestor } = require("utils/messaging")
Sentry = require("@sentry/browser")
_             = require("underscore")


class SlidesView extends BaseSlidesView

  id: "slides-view"

  template: require("templates/slides")

  initialize: ->
    super

    w = window.innerWidth
    h = window.innerHeight
    @_debounceResize = _.debounce (=>
      @onResize()
    ), 300

    # orientation change for App / resize for Web
    window.addEventListener device.events.resize, @_debounceResize
    window.addEventListener "keypress", @onKeyPress

  render: (params) ->
    @hasRendered = true
    @options = @getExtraConfig(params)

    @el.innerHTML = @template(@options)

    @el.classList.add("direction-#{@options.config.direction or "ltr"}")

    if @options?.styleConfiguration?.soundDisabled is true
      Sound.disableSystemSounds?()

    @createSlideViews(@options.config, params)

    index = @cleanIndex(@options.index)
    document.title = @options.title if @options.title

    @sizeContent(@options.forceResize)
    initialSlideWidth = @slideViews[index].el.offsetWidth

    afterRender = =>
      @createScroller(params)
      @goToPage(index, 0) # no delay on the first render, adding it might cause an issue
      Application.publish("event:thomas-ready") {}

      if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW
        targetOrigin = getValidAncestor()
        window.parent.postMessage("thomas-ready", targetOrigin) unless !targetOrigin

      # For devices with high laten cy/poor IO performance, trigger a resize
      # to allow poorly rendered first slides views to recalculate as needed
      window.setTimeout (=>
        if @slideViews[index]?.el.offsetWidth isnt initialSlideWidth
          @slideViews[index]?.trigger "resize"
      ), 1500

    if params.isRefresh
      afterRender()
    else
      window.setTimeout afterRender, 300

    Backbone.trigger("ready")

  display: (callback, params) ->
    index = @cleanIndex(params.index)

    if @currentIndex isnt index and @options.config.contextAllowsFreeNavigation
      @toggleViewInDOM(@slideViews[index], true)
      @slideViews[index].el.offsetWidth
      @goToPage(index, params.ms)

    callback()

  removeScroller: ->
    @scroller.off "scrollEnd"
    @scroller.destroy()

  createScroller: (params) ->
    if @options?.config?.fade
      @scroller =
        currentPage: pageX: 0
        scroller: @el.querySelector("#slides-scroller")
        goToPage: (nextPage) =>
          prevPage = @scroller.currentPage.pageX
          @scroller.currentPage.pageX = nextPage
          @onScrollEnd()

    else
      @removeScroller() if @scroller?

      indicators = []

      if @options.config.background
        indicators.push
          el: "#slides-background-wrap"
          resize: false
          shrink: "clip"
          listenY: false
          speedRatioX: 1 / (@slideViews.length - 1) * 0.5
          ignoreBoundaries: true

      if @options.config.indicator
        indicators.push
          el: "#indicator"
          resize: true
          shrink: "clip"
          listenY: false
          ignoreBoundaries: true

      @scroller = new IScroll @el.querySelector("#slides"),
        scrollX: true
        scrollY: false
        snap: true
        tap: "scrolltap"
        snapThreshold: 0.15
        momentum: false
        resizePolling: 9999999
        eventPassthrough: true
        indicators: indicators
        preventDefaultException:
          tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|IFRAME)$/

      if not params.cms and not params.public
        @scroller.on "scrollEnd", =>
          @onScrollEnd()

      if @options.config.locked
        @toggleScroller(false)

    if @options.config.pageNumbers
      @pageNumber = @el.querySelector("#lesson-header-nav-page-number")
      @screenReaderPageNumber = @el.querySelector("#sr-page-number")

  optionsForView: (el, data = {}, config = {}, params = {}, slideIndex) ->
    _.extend {},
      data,
      {
        slideIndex: slideIndex
        lessonConfiguration: config
        enableStars: @options.enableStars
        scorm: @options.scorm
        contextRequiresExitButton: @options.contextRequiresExitButton
      },
      el: el
      lock:      => @toggleScroller(false, arguments...)
      unlock:    => @toggleScroller(true)
      next: (ms) => @goToPage(@currentIndex + 1, ms)
      prev: (ms) => @goToPage(@currentIndex - 1, ms)
      config:    => @options.config
      notInteractable: @notInteractable or params.interactable == false
      withoutNarration: params.withoutNarration

  goToPage: (index, ms = 600, options = {}) ->
    if (index isnt @currentIndex or not @currentIndex?) and
        0 <= index < @slideViews.length

      prevView = @slideViews[@currentIndex]
      nextView = @slideViews[index]

      @toggleViewInDOM(nextView, true)

      @trigger("goToPage", arguments...)
      
      if (window.ED_LMS_PREVIEW || window.ED_PUBLIC_PREVIEW)
        targetOrigin = getValidAncestor()
        window.parent.postMessage({
          type: "go-to-page",
          value: index
        }, targetOrigin) unless !targetOrigin or options.fromPreview
      else
        Application.publish("event:go-to-page") { value: index }

      prevView?.beforeHide?()
      nextView.render()
      nextView.beforeShow?()

      view.el.classList.remove("visible") for view in @slideViews
      nextView.el.classList.add("visible")

      Sentry.setContext('slide', {
        slide_index: index + 1
      });

      if @scroller?.pages?.length and @slideViews.length > 1
        { wrapperWidth, maxScrollX, minScrollX } = @scroller

        unless @options.config.locked or
               minScrollX > -index * wrapperWidth > maxScrollX
          @toggleScroller(true)

        @scroller.goToPage(@getIndexForDirection(index), 0, ms)

        window.setTimeout (=> @onScrollEnd()), ms

      else if not options.fromPreview
        @onScrollEnd()

  cleanIndex: (index) ->
    if _.isNaN(+index)
      (i for slide, i in @slideViews when slide.el?.id is index)[0] or 0
    else
      _.limit(index - 1, 0, @slideViews.length - 1)

  getIndexForDirection: (index) ->
    if @options.config.direction is "rtl"
      (@slideViews.length - 1 - index)
    else
      index

  onScrollEnd: ->
    i = @getIndexForDirection +@scroller?.currentPage?.pageX
    return if _.isNaN(i)

    if i isnt @currentIndex
      for slideView, j in @slideViews
        if @options.config.fade
          slideView.el.style.opacity = if j is i then 1 else 0
          slideView.transition slideView.el, "opacity 300ms"
          isActive = j is i or j is @currentIndex
        else
          isActive = j - 1 <= i <= j + 1

        @toggleViewInDOM(slideView, isActive)

        @pageNumber?.innerText = i + 1
        @screenReaderPageNumber?.innerText = i + 1


      @hideView(@slideViews[@currentIndex]) if @currentIndex?
      @showView(@slideViews[i])

      @currentIndex = i
      app.router.doNavigate("slide/#{i + 1}") if not @disableHistory?

      currentViewElement = @slideViews[@currentIndex].el

      # Fixes an issue where resizing a parent element of an audio
      # element doesn't properly resize the audio element.
      # This forces the audio element to be repainted at the end of a
      # slide navigation, and only makes it visible at the end.
      if currentViewElement and currentViewElement.replaceWith?
        audioElements = currentViewElement.querySelectorAll("audio")

        for audioElement in audioElements
            clonedNode = audioElement.cloneNode true
            audioElement.replaceWith clonedNode
            clonedNode.style.visibility = "visible"

  # Listeners for "resize" and "orientationchange" are debounced.
  # Once the method fires, it resize content with a delayed scroller refresh.
  # Sometimes in IE, the resize event fires before rendering.
  onResize: (e) =>
    if @hasRendered
      # wait class to be added on the body
      window.clearTimeout @resizeTimeout
      @resizeTimeout = window.setTimeout =>
        @sizeContent(true)
        @scroller?.refresh?()
        window.clearTimeout @scroller?.resizeTimeout
      , 0

  toggleViewInDOM: (slideView, isActive) ->
    return unless slideView
    if slideView.__isActive isnt isActive
      slideView.__isActive = isActive

      if isActive and slideView.el.parentNode isnt @scroller?.scroller
        @scroller?.scroller.appendChild slideView.el
      else if not isActive and slideView.el.parentNode is @scroller?.scroller
        @scroller?.scroller.removeChild slideView.el

  hideView: (slideView) ->
    slideView.el.classList.remove "active"
    slideView.undelegateEvents?()
    slideView.stopMedia()
    slideView.hide?()
    @trigger("hideView", slideView)
    slideView.el.setAttribute('aria-hidden', 'true')
    slideView.el.blur()

  showView: (slideView) ->
    return unless slideView?
    slideView.el.offsetWidth
    slideView.el.classList.add "active"
    slideView.delegateEvents?()
    slideView.show?()
    slideView.el.setAttribute('aria-hidden', 'false')
    # ignore accessibility auto focus on the LMS or, this can mess up the authoring tool input focus
    if !window.ED_LMS_PREVIEW and !window.ED_PUBLIC_PREVIEW
      document.getElementById('skip-content')?.focus()
    @trigger("showView", slideView)

  toggleScroller: (isEnabled, direction, bounce = true) ->
    return if @options.config.fade

    { wrapperWidth, currentPage: { pageX } } = @scroller
    index = @getIndexForDirection pageX

    switch direction
      when "left", "l"
        @scroller.minScrollX = -wrapperWidth * index
        @scroller.options.bounce = bounce
      when "right", "r"
        @scroller.maxScrollX = -wrapperWidth * index
        @scroller.options.bounce = bounce
      else
        @scroller.options.bounce = bounce
        @scroller.refresh()
        @scroller.enabled = isEnabled

  sizeContent: (forceResize = false) ->
    if @scroller?.wrapperWidth is @el.offsetWidth and not forceResize
      return
    
    if @scroller? or @slideViews.length is 1
      @slideViews[@currentIndex]?.trigger("beforeResize")

    outerEl = $("#slides")
    innerEl = $("#slides-scroller")

    width = outerEl[0].offsetWidth
    
    if @options?.config?.fade
      for slideView, i in @slideViews
        slideView.el.style.width = width + "px"

    else
      innerEl.css('width', width * @slideViews.length + "px")

      for slideView, i in @slideViews
        slideView.el.style.width = width + "px"
        slideView.el.style.left  = width * @getIndexForDirection(i) + "px"

    if @scroller? or @slideViews.length is 1
      @slideViews[@currentIndex]?.trigger("resize", { width })

    @scroller?.refresh?()

  onKeyPress: (e) =>
    @slideViews[@currentIndex]?.trigger(e.type, e)

  stopListening: ->
    window.removeEventListener "resize", @_debounceResize
    window.removeEventListener "orientationchange", @_debounceResize
    window.removeEventListener "keypress", @onKeyPress

    super

module.exports = SlidesView
